'use client';

import { HelpCircleIcon } from '@terra/ui-icons';
import { Box } from '@terra/ui-styled-system';
import { Tooltip } from './tooltip';

export type FilterOptionHelpTooltipProps = {
  title: string;
  iconSize?: number;
};
export function FilterOptionHelpTooltip({
  title,
  iconSize = 14,
}: FilterOptionHelpTooltipProps) {
  return (
    <Tooltip title={title} maxW="280px">
      <Box
        as="span"
        display="inline-flex"
        flexShrink={0}
        onClick={(event) => event.stopPropagation()}
        onPointerDown={(event) => event.stopPropagation()}
      >
        <HelpCircleIcon size={iconSize} />
      </Box>
    </Tooltip>
  );
}
